export enum managePaths {
  root = '/manage',
  mixers = '/manage/mixers',
  create = '/manage/mixers/create',
  edit = '/manage/mixers/edit',
  feedingPeriodList = '/manage/feeding-periods',
  operators = '/manage/operators',
  settings = '/manage/settings',
  dataTools = '/manage/data-tools',
  zoneControl = '/manage/zone-control',
  contacts = '/manage/contacts',
  sharing = '/manage/sharing',
}
